import { render, staticRenderFns } from "./InventoryHandlingTable.vue?vue&type=template&id=7440114a&scoped=true&"
import script from "./InventoryHandlingTable.vue?vue&type=script&lang=js&"
export * from "./InventoryHandlingTable.vue?vue&type=script&lang=js&"
import style0 from "./InventoryHandlingTable.vue?vue&type=style&index=0&id=7440114a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7440114a",
  null
  
)

export default component.exports